import { Button, Dropdown, Menu, Typography } from "antd";
import React, { FC } from "react";
import { useIsDev } from "../containers/user/hooks";
import { useCopyToClipboardAndShowToast } from "../util/hooks";
import { ToolFilled } from "@ant-design/icons";

interface Props {
  workspaceId?: string;
  organizationId?: string;
}
export const DebugMenu: FC<Props> = ({ workspaceId, organizationId }) => {
  const copy = useCopyToClipboardAndShowToast();
  const isDev = useIsDev();
  if (!isDev) return null;
  return (
    <Dropdown
      trigger={["click"]}
      overlay={
        <Menu>
          {!!workspaceId && (
            <Menu.Item onClick={() => copy(workspaceId)}>
              {"Workspace ID: "}
              <Typography.Text code copyable>
                {workspaceId}
              </Typography.Text>
            </Menu.Item>
          )}
          {!!organizationId && (
            <Menu.Item onClick={() => copy(organizationId)}>
              Organization ID:{" "}
              <Typography.Text code copyable>
                {organizationId}
              </Typography.Text>
            </Menu.Item>
          )}
        </Menu>
      }
    >
      <Button>
        <ToolFilled />
      </Button>
    </Dropdown>
  );
};
